import { useState } from 'react';
import './UpdateBar.css';

interface UpdateBarProps {
  version: string;
  onReload: () => void;
}

/**
 * Update notification toast shown when a new app version is available.
 * Fixed at bottom of viewport, dismissible, with reload button.
 */
export function UpdateBar({ version, onReload }: UpdateBarProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const message = version && version !== 'unknown' && version !== 'available'
    ? `Version ${version} is available`
    : 'A new version is available';

  return (
    <div className="update-bar" role="alert">
      <div className="update-bar-content">
        <span className="update-bar-message">{message}</span>
        <div className="update-bar-actions">
          <button className="update-bar-reload" onClick={onReload}>
            Reload
          </button>
          <button
            className="update-bar-dismiss"
            onClick={() => setIsVisible(false)}
            aria-label="Dismiss update notification"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
